<!-- Title Row -->
<div class="flex h-[50px] items-center border bg-aux-gray-light p-3 text-aux-black">
  <!-- Icon -->
  <aux-icon [name]="icon()" />

  <!-- Title and Counts -->
  <span class="ml-1 flex-grow font-normal">{{ title() }} ({{ complete() }}/{{ total() }})</span>

  <!-- Complete button -->
  @if (sectionCompleted()) {
    <div class="mr-2 flex items-center font-bold text-aux-green-dark">
      <span class="mr-1">Complete</span>
      <aux-icon name="Check" />
    </div>
  } @else if (!isLoadingList() && total() && total() !== '0') {
    <!-- Lock All button -->
    <div [auxTooltip]="tooltip()">
      <aux-button
        variant="hyperlink"
        [attr.data-pendo-id]="pendoID()"
        label="Lock All"
        (clickEmit)="lockAllEmit.emit()"
        [disabled]="disabledLock()"
        icon="Lock"
      />
    </div>
  }
</div>
